<template>
  <TransitionRoot as="template" :show="open">
    <Dialog
      as="div"
      class="relative z-50"
      @close="props.handleMemberClick(null)"
    >
      <TransitionChild
        as="template"
        enter="ease-out duration-300"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="ease-in duration-200"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <div
          class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
        />
      </TransitionChild>

      <div class="fixed inset-0 w-screen overflow-y-auto">
        <div
          class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0"
        >
          <TransitionChild
            as="template"
            enter="ease-out duration-300"
            enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leave-from="opacity-100 translate-y-0 sm:scale-100"
            leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <DialogPanel
              class="relative transform overflow-hidden bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-7xl"
            >
              <div class="modal-bg">
                <div class="md:flex sm:items-start gap-12">
                  <div
                    class="mx-auto flex flex-shrink-0 items-center justify-center sm:mx-0 team-modal-image"
                  >
                    <img
                      :src="member.teamconfiguration?.memberImage?.sourceUrl"
                      class="h-full w-full object-cover object-top"
                    />
                  </div>
                  <div class="mt-12 py-4 md:py-32">
                    <div class="txt-l text-center md:text-left">
                      {{ member.title }}
                    </div>
                    <div class="mt-2">
                      <p class="txt-t text-center md:text-left">
                        {{ member?.teamconfiguration?.position }}
                      </p>
                    </div>
                    <div class="mt-8 modal-text p-4 md:p-0 md:pr-12">
                      {{ member?.teamconfiguration?.description }}
                    </div>
                    <div
                      v-if="member?.teamconfiguration?.linkedin"
                      class="mt-8 modal-text p-4 md:p-0"
                      @mouseenter="
                        setCursor('', null, {
                          'font-size': '14px',
                          width: '0px',
                          height: '0px',
                          background: '#FFF',
                          'z-index': 51,
                          position: 'absolute',
                        })
                      "
                      @mouseleave="
                        setCursor(null, null, {
                          'font-size': '14px',
                          background: '#FFC800',
                          width: '25px',
                          height: '25px',
                          'z-index': '-1',
                        })
                      "
                    >
                      <a
                        :href="member?.teamconfiguration?.linkedin"
                        target="_blank"
                        rel="noopener noreferrer"
                        tabindex="-1"
                        >LinkedIn</a
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="absolute top-0 right-0 text-xl p-4"
                @click="closeModal"
                @mouseenter="
                  setCursor($t('close'), () => {}, {
                    'font-size': '14px',
                    width: '100px',
                    height: '100px',
                    background: '#FFF',
                    'z-index': 51,
                    position: 'absolute',
                  })
                "
                @mouseleave="
                  setCursor(null, null, {
                    'font-size': '14px',
                    background: '#FFC800',
                    width: '25px',
                    height: '25px',
                    'z-index': '-1',
                  })
                "
              >
                ✖
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script setup>
// watch(member, async (newValue) => {
//
// })

import { ref } from "vue";
import {
  Dialog,
  DialogPanel,
  DialogTitle,
  TransitionChild,
  TransitionRoot,
} from "@headlessui/vue";

const props = defineProps({
  handleMemberClick: Function,
  member: Object,
  setCursor: Function,
});

const open = ref(true);
function closeModal() {
  open.value = false;
  props.handleMemberClick(null);
}
</script>

<style lang="scss">
.modal-bg {
  background: #ffc800;
}

.modal-text {
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 300;
  line-height: 26px;
}

.team-modal-image {
  height: 800px;
  width: 580px;

  @media (max-width: 1024px) {
    //height: 100%;
    width: 420px;
  }
  @media (max-width: 875px) {
    height: 800px;
    width: 320px;
  }
  @media (max-width: 768px) {
    height: 400px;
    width: 100%;

    img {
      object-position: 0% 15% !important;
    }
  }
  @media (max-width: 600px) {
    height: 300px;
    width: 100%;

    img {
      object-position: 0% 15% !important;
    }
  }
}
</style>
